import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Main from './pages/Main';
import Stream from './pages/Stream';
import StreamStart from './pages/StreamStart';
import StreamEnd from './pages/StreamEnd';
import StreamStart2 from './pages/StreamStart2';
import StreamEnd2 from './pages/StreamEnd2';

const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/stream" element={<Stream />} />
        <Route path="/streamStart" element={<StreamStart />} />
        <Route path="/streamEnd" element={<StreamEnd />} />
        <Route path="/streamStartHel" element={<StreamStart2 />} />
        <Route path="/streamEndHel" element={<StreamEnd2 />} />
      </Routes>
    </div>
  );
};

export default App;
